import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import { CLS_PREFIX } from '../../constants';
var DEFAULT_ICONS = ['clock', 'emoticon-smile', 'rocket', 'sand-clock', 'sleep', 'web', 'star'];

var useIcon = function useIcon(icons, initialCursor, isSync) {
  var targetRef = useRef(null);

  var _useState = useState(initialCursor),
      _useState2 = _slicedToArray(_useState, 2),
      cursor = _useState2[0],
      setCursor = _useState2[1];

  useEffect(function () {
    var target = targetRef.current;

    var listener = function listener() {
      if (isSync()) {
        setCursor(function (c) {
          return (c + 2) % icons.length;
        });
      }
    };

    if (target) {
      target.addEventListener('animationiteration', listener);
    }

    return function () {
      if (target) {
        target.removeEventListener('animationiteration', listener);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [icons]);
  return {
    name: icons[cursor],
    targetRef: targetRef
  };
};

var IconsLoader = function IconsLoader(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "icons-loader") : _ref$baseClassName,
      className = _ref.className,
      icons = _ref.icons,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "icons"]);

  var syncRef = useRef(0);
  icons = icons && icons.length > 0 ? icons : DEFAULT_ICONS;
  var icon1 = useIcon(icons, 0, function () {
    if (syncRef.current === 0) {
      syncRef.current += 1;
      return true;
    }

    return false;
  });
  var icon2 = useIcon(icons, 1, function () {
    if (syncRef.current === 1) {
      syncRef.current -= 1;
      return true;
    }

    return false;
  });
  return React.createElement("div", _extends({
    className: classNames(baseClassName, className)
  }, props), React.createElement("div", {
    className: classNames("".concat(baseClassName, "__icon"), "".concat(baseClassName, "__icon--1")),
    ref: icon1.targetRef
  }, React.createElement(Icon, {
    name: icon1.name,
    size: "64"
  })), React.createElement("div", {
    className: classNames("".concat(baseClassName, "__icon"), "".concat(baseClassName, "__icon--2")),
    ref: icon2.targetRef
  }, React.createElement(Icon, {
    name: icon2.name,
    size: "64"
  })));
};

export default IconsLoader;